module.exports = __webpack_public_path__ + "static/img/3.a4e4283.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3.png
// module id = ZK0V
// module chunks = 1